<template>
  <div class="oa-content">
    <div class="oa-title">
      <span>{{ oaTitle }}</span>
      <div class="toggleLang">
        <div class="functional-item">
          <el-dropdown @command="handleLangCommand">
            <span class="el-dropdown-link">
              {{ currLanguage }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in languages"
                :key="item.value"
                :command="item.value"
                >{{ item.desc }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="content">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Service from '@/service'

export default {
  data() {
    return {
      title: "",
      languages: [
        {
          desc: "简体中文",
          value: "zh_CN",
        },
        {
          desc: "繁體中文",
          value: "zh_TW",
        },
        {
          desc: "English",
          value: "en_US",
        },
      ],
    };
  },
  watch: {
    language: {
      handler(value) {
        if(value) {
          this.$i18n.locale = value;
          console.log(this.$i18n.locale)
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["handleSetLanguage", 'handleOALanguage']),
    handleLangCommand(lang) {
      // 调用actions.setLanguage
      this.handleSetLanguage(lang);
    },
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      oaTitle: (state) => state.oaTitle,
    }),
    currLanguage() {
      if (this.language) {
        this.role && this.handleRoleCommand(this.role);
        return this.languages.filter((item) => item.value == this.language)[0].desc;
      } else {
        return "简体中文";
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    // ...
    Service.fetch({
      url: 'homepageGetUserLang',
    }).then(response => {
      if(response.code == '1') {
        const { data } = response
        next(vm => {
          vm.$store.dispatch('handleOALanguage', data)
          vm.$i18n.locale = data;
          vm.$cookies.set("language", data);
        })
      }
    })
  },
  created() {},
};
</script>
<style lang="less" scoped>
.oa-content {
  background-color: #f2f2f2;
}

.oa-title {
  position: relative;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  background-color: #fff;
}

.toggleLang {
  position: absolute;
  right: 60px;
  top: 0px;
  ::v-deep .el-dropdown {
    display: inline-block;
    height: 32px;
    line-height: 20px;
    padding: 4px 10px;
    border: solid 1px #f2f2f2;
    border-radius: 6px;
  }
}

.content {
  margin: 30px;
}
</style>
